import type { FC, MouseEvent } from 'react';
import CropFreeIcon from '@mui/icons-material/CropFree';
import { useTranslation } from 'react-i18next';
import type { Session } from '../../../../../../core/domain/Session';
import useZoomOnSession from '../../use-zoom-on-session';
import IconButton from '../../../../../../design/IconButton';

export type Props = {
    session: Session;
};
const ZoomOption: FC<Props> = ({ session }) => {
    const { t } = useTranslation();
    const zoomOnSession = useZoomOnSession(session);

    const handleZoomOnSession = (e: MouseEvent) => {
        e.stopPropagation();
        zoomOnSession();
    };

    return (
        <IconButton onClick={handleZoomOnSession} label={t('networkMap.sessionsPanel.zoomOnSession')}>
            <CropFreeIcon />
        </IconButton>
    );
};

export default ZoomOption;
